// assets/rebuy-price-sync.js

function initRebuyPriceSync() {
  const productBuyPrice = document.querySelector('product-buy-price[data-price][form]');
  
  if (!productBuyPrice) return;
  
  const basePrice = parseInt(productBuyPrice.getAttribute('data-price')) || 0;
  
  function updateButtonPrice() {
    let totalPrice = basePrice;
    
    const checkedAddons = document.querySelectorAll('#rebuy-widget-254975 .rebuy-addon__item-checkbox:checked');
    
    checkedAddons.forEach(checkbox => {
      const addonItem = checkbox.closest('.rebuy-addon__item');
      const priceElement = addonItem?.querySelector('.rebuy-money');
      
      if (priceElement) {
        const priceText = priceElement.textContent.replace(/[^0-9.]/g, '');
        const priceInCents = Math.round(parseFloat(priceText) * 100);
        if (!isNaN(priceInCents)) {
          totalPrice += priceInCents;
        }
      }
    });
    
    productBuyPrice.setAttribute('data-price', totalPrice);
    productBuyPrice.textContent = `$${(totalPrice / 100).toFixed(2)}`;
    
    if (window.Currency?.convertAll) {
      clearTimeout(window.rebuyPriceSyncTimeout);
      window.rebuyPriceSyncTimeout = setTimeout(() => {
        window.Currency.convertAll('CAD', window.Currency.currentCurrency || 'CAD');
      }, 200);
    }
  }
  
  const observer = new MutationObserver(() => {
    const widget = document.querySelector('#rebuy-widget-254975');
    if (widget) {
      widget.addEventListener('change', (e) => {
        if (e.target.classList.contains('rebuy-addon__item-checkbox')) {
          setTimeout(updateButtonPrice, 100);
        }
      });
      observer.disconnect();
    }
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
  
  setTimeout(() => {
    if (document.querySelector('#rebuy-widget-254975')) {
      updateButtonPrice();
    }
  }, 500);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRebuyPriceSync);
} else {
  initRebuyPriceSync();
}